module.exports = __webpack_public_path__ + "img/16l012-02.c8787e5d.png";